export default "__VITE_ASSET__234543f1__"